export const AppBannerIcon = () => (
  <svg width={40} height={41} viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_2913_114"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={40}
      height={41}>
      <rect y="0.5" width={40} height={40} rx={4} fill="url(#paint0_linear_2913_114)" />
    </mask>
    <g mask="url(#mask0_2913_114)">
      <rect y="0.5" width={40} height={40} fill="url(#paint1_linear_2913_114)" />
      <g filter="url(#filter0_d_2913_114)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2648 25.5745C27.295 29.0854 23.7018 29.2082 23.7018 29.2082C23.7018 29.2082 23.6962 29.2008 23.6889 29.1889C23.2054 29.2952 22.7099 29.3327 22.219 29.2988L11.8777 29.2998C11.8721 29.2998 11.8666 29.2979 11.8611 29.297H11.2167V29.2952V28.6842C11.2149 28.6677 11.2112 28.6503 11.2112 28.6329V18.2942C11.179 17.8042 11.2158 17.3114 11.3215 16.8296L11.3197 16.8287C11.3197 16.8287 11.4419 13.2353 14.9543 12.2661C18.4658 11.297 20.2335 13.7739 20.2335 13.7739C20.2335 13.7739 21.6969 15.1323 21.5057 18.0561C21.4974 18.4215 21.4533 18.787 21.3678 19.1452C21.832 19.0343 22.3082 18.9904 22.7816 19.0096C25.4933 18.9363 26.7564 20.2957 26.7564 20.2957C26.7564 20.2957 29.2346 22.0635 28.2648 25.5745ZM29.2893 18.7292C27.8847 17.3241 26.0361 16.5208 24.0561 16.4484C24.046 16.1883 24.0212 15.9282 23.9862 15.6699C23.9412 15.3383 23.8768 15.0104 23.7895 14.687C23.6801 14.284 23.534 13.8919 23.3621 13.5127C22.976 12.6627 22.441 11.8823 21.7755 11.2164C21.3425 10.7831 20.8673 10.4094 20.3589 10.0943C19.1345 9.33309 17.7198 8.92456 16.2417 8.92456C14.4381 8.92456 12.7284 9.53186 11.3431 10.6475C11.1225 10.8243 10.9101 11.0139 10.707 11.2173C10.1141 11.8099 9.62688 12.4887 9.25735 13.2224C9.01007 13.7124 8.81612 14.2263 8.67639 14.7566C8.46773 15.5526 8.38408 16.3852 8.43463 17.2252L8.43372 29.6771C8.43372 29.6789 8.43463 29.6807 8.43463 29.6817V32.0641H8.43372H10.7529C10.7778 32.0651 10.8017 32.0678 10.8274 32.0678H23.2803C23.4402 32.0779 23.6011 32.0825 23.761 32.0825C25.8514 32.0825 27.8158 31.27 29.2893 29.7962C32.3411 26.745 32.3411 21.7804 29.2893 18.7292Z"
          fill="#4D52E3"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2913_114"
        x="3.42029"
        y="6.92456"
        width="33.1579"
        height="33.1578"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2913_114" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2913_114"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2913_114"
        x1={20}
        y1="0.5"
        x2={20}
        y2="40.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#57B8EA" />
        <stop offset={1} stopColor="#2765D9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2913_114"
        x1={20}
        y1="0.5"
        x2={20}
        y2="40.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#DBDCF9" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
